import PricingBlockPreview from "./PricingBlockPreview";

export default PricingBlockPreview;